export function CookieBanner({ onAccept, onDecline }) {
  return (
    <div
      role="region"
      aria-label="Cookie choice"
      className="fixed inset-x-0 bottom-0 z-[60] border-t border-pub-gray-200 bg-white px-4 py-4 shadow-[0_-8px_24px_rgba(15,23,42,0.08)] sm:px-6"
    >
      <div className="mx-auto flex max-w-[1200px] flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-6 text-pub-gray-700">
          We use Google Analytics cookies to see how visitors use this website so we can improve
          it. They are only used on these public pages, never inside the MyDocUploads app.
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={onDecline}
            className="rounded-full border border-pub-gray-300 px-5 py-2 text-sm font-semibold text-pub-navy hover:bg-pub-gray-50"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={onAccept}
            className="rounded-full bg-pub-blue px-5 py-2 text-sm font-semibold text-white hover:opacity-90"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
